import React from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import { Col, Row } from "react-bootstrap"
import { DckSelectors, DckActionCreators } from "dck-redux"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"

import * as ItemTypes from "../../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SingleSelectTable from "../../fragments/SingleSelectTable"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import {
  BooleanStatuses,
  CardType,
  fillingZeroUtility,
  formatCurrency,
  sortDate
} from "../../../lib/utils"
import UIAvatar from "../../fragments/UIAvatar"
import FinancierBucketCard from "./Card"
import { getBucketPaymentDetails, getLoansTotalRepayment } from "../financierHelper"

class ListFinancierBuckets extends React.Component {

  _isMounted = false

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()
  isAdminOrAccountant = this.isAdmin || this.authenticated.isAccountant()

  state = {
    selectedRow: null,
    isSelected: false,
    allUpfrontPayment: 0,
    allTotalRepayment: 0,
    runningRepaymentSummary: false,
  }

  componentDidMount() {
    this._isMounted = true
    this.props.loadData()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  loadPaymentDetails = financierBucket => {

    const { allUpfrontPayment, allFineractIds } = getBucketPaymentDetails(financierBucket)
    this.setState({
      allUpfrontPayment,
      allTotalRepayment: 0,
      runningRepaymentSummary: false,
    })

    if (allFineractIds.length) {

      this.setState({ runningRepaymentSummary: true })
      getLoansTotalRepayment(allFineractIds)
      .then(allTotalRepayment => {

        if (this._isMounted) {
          this.setState({ allTotalRepayment })
        }
      })
      .catch(error => console.error(error))
      .finally(() => {

        if (this._isMounted) {
          this.setState({ runningRepaymentSummary: false })
        }
      })
    }
  }

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.nbBatches.cleanFiltered()
    this.refs.currencyCode.cleanFiltered()
    this.refs.amount.cleanFiltered()
    this.refs.purchaseCost.cleanFiltered()
    this.refs.sellingCost.cleanFiltered()
    this.refs.balance.cleanFiltered()
    this.refs.margin.cleanFiltered()
    this.refs.isFull.cleanFiltered()
    this.refs.closed.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
  }

  itemSelected = (selectedRow, isSelected) => {

    this.setState({
      selectedRow,
      isSelected
    })

    const { buckets } = this.props,
    financierBucket = isSelected && selectedRow
      ? this.getElementById(selectedRow.id, buckets) : null

    if (financierBucket) {
      this.loadPaymentDetails(financierBucket)
    }
  }

  updateLink = id => `/financiers/buckets/${id}/update`

  detailsLink = id => `/financiers/buckets/${id}/detail`

  renderUpdateLink = id => {

    if(!this.isAdmin) return null
    return (
      <Link to={ this.updateLink(id) } className="p-5">
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  renderDetailLink = (id, content) =>
    <Link to={ this.detailsLink(id) } className="p-5">
      { content }
    </Link>

  renderTable = buckets => (
    <SingleSelectTable
      items={ buckets }
      addNewLabel="Add Bucket"
      addNewHandler={() => browserHistory.push("/financiers/buckets/create")}
      exportCSV={ this.isAdminOrAccountant }
      csvFileName='buckets.csv'
      shouldRenderToolbar={ this.isAdminOrAccountant }
      itemSelected={ this.itemSelected }
    >
      <TableHeaderColumn
        dataField="id"
        isKey
        dataAlign="center"
        dataFormat={(_, row) => <UIAvatar name={ row.name } size={ 28 } />}
        csvHeader="Bucket ID"
        width='48'
      />

      <TableHeaderColumn
        ref='name'
        dataField="name"
        dataSort
        dataAlign="center"
        filter={{ type: "TextFilter", delay: 1000 }}
        dataFormat={(_, { id, name, isFull, closed }) =>
          this.renderDetailLink(id, <span className={(isFull || closed) ? 'red' : ''}>{ name }</span>)}
        csvHeader="Name"
        columnClassName="min-w-120"
      >
        Name
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='nbBatches'
        dataField="nbBatches"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={value => fillingZeroUtility(value)}
        csvHeader="Nb Batches"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        NB batches
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='currencyCode'
        dataField="currencyCode"
        dataSort
        filter={{ type: "TextFilter", delay: 1000 }}
        dataAlign="center"
        csvHeader="Currency code"
        columnClassName="min-w-120"
      >
        Currency code
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='amount'
        dataField="amount"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="Amount"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        Amount
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='purchaseCost'
        dataField="purchaseCost"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="T. purchase cost"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        T. purchase cost
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='sellingCost'
        dataField="sellingCost"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="T. selling price"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        T. selling price
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='balance'
        dataField="balance"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="Balance"
        columnClassName="min-w-120"
      >
        Balance
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='margin'
        dataField="margin"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="Margin"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        Margin
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='isFull'
        dataField="isFull"
        dataAlign="center"
        dataSort
        tdStyle={{ verticalAlign: 'middle' }}
        dataFormat={value => value ? <FontAwesome className="green" name='check' /> : ''}
        filter={{ type: "SelectFilter", options: BooleanStatuses }}
        csvHeader="Is full"
        width="90"
      >
        Is full
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='closed'
        dataField="closed"
        dataAlign="center"
        dataSort
        tdStyle={{ verticalAlign: 'middle' }}
        dataFormat={ value => value ? <FontAwesome style={{ color: 'green' }} name='check' /> : ''}
        filter={{ type: "SelectFilter", options: BooleanStatuses }}
        csvHeader="Closed"
        width="90"
      >
        Closed
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='createdOnFormatted'
        dataField="createdOnFormatted"
        dataAlign="center"
        dataSort
        sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
        filter={{ type: "DateFilter", delay: 1000 }}
        csvHeader="Created On"
        columnClassName='text-xs'
        width="140"
      >
        Created On
      </TableHeaderColumn>

      <TableHeaderColumn
        dataAlign="center"
        width="80px"
        dataFormat={(_, row) =>
        <span className="flex-detail">
          { this.renderDetailLink(row.id, <FontAwesome name="eye" title='View' />) }
          { this.renderUpdateLink(row.id) }
        </span>}
      />
    </SingleSelectTable>
  )

  getElementById = (id, data) => data.find(item => item.id === id)

  render() {
    const { buckets, setFinancierBucket, removeFinancierBucket } = this.props,

    { selectedRow, isSelected, allUpfrontPayment, allTotalRepayment, runningRepaymentSummary } = this.state,
    financierBucket = selectedRow ? this.getElementById(selectedRow.id, buckets) : null,
    meetCond = isSelected && !!financierBucket

    return (
      <div>
        <CustomBreadCrumb activeText='Buckets' data={ [{ url: '/financiers', title: 'Financiers' }] } />

        <Row>
          <Col md={ meetCond ? 8 : 12 }>
            <ClearFiltersButton onClick={ this.doClearFilters } />
            { this.renderTable(buckets) }
          </Col>

          { meetCond &&
            <Col md={4}>
              <FinancierBucketCard
                financierBucket={ financierBucket }
                setFinancierBucket={ setFinancierBucket }
                removeFinancierBucket={ removeFinancierBucket }
                cardType={ CardType.SMALL }
                allUpfrontPayment={ allUpfrontPayment }
                allTotalRepayment={ allTotalRepayment }
                runningRepaymentSummary={ runningRepaymentSummary }
              />
            </Col>
          }
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const buckets = DckSelectors.selectAllItems(state, ItemTypes.FinancierBucket)
  return { buckets }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.FinancierBucket)),
  setFinancierBucket: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.FinancierBucket, id, data)),
  removeFinancierBucket: id => dispatch(DckActionCreators.itemRemove(ItemTypes.FinancierBucket, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListFinancierBuckets)



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/List.js